import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { FactoryExportID } from "models";

type ExportDataPayload = {
  factory_export_id: FactoryExportID;
};

export const useExportDataMutation = () =>
  useTypedMutation<ExportDataPayload, string>({
    mutationFn: async payload => (await ApiInstance.post("/exports/download", payload, ENV.reportsBaseURL)).data.url,
    onSuccess: () => null
  });
